import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';

/**
 * @todo Implement browser locale
 */
class ComputedPriceField extends React.Component {
    render() {
        const { elStyle, record, source } = this.props;

        if (utils.isEmpty(record)) {
            return null;
        }

        const currency = record.currency || 'EUR';
        const value = record[source] || 0;
        const locale = this.context.config.language.system;

        return <span style={ elStyle }>{ utils.formatPrice(value, currency, locale) }</span>;
    }
}

ComputedPriceField.contextTypes = {
    config: PropTypes.object,
};

ComputedPriceField.propTypes = {
    elStyle: PropTypes.object,
    record: PropTypes.object,
    source: PropTypes.string,
};

export default ComputedPriceField;



// WEBPACK FOOTER //
// ./src/components/field/ComputedPriceField.js